/**
 * Converts internal order state to a user-friendly status label.
 * @param {string} state - The internal state value.
 * @returns {string} - The display status.
 */
export const getOrderStatusLabel = (state) => {
  let message, heading, color
  if (state == "Payment Verified") {
    heading = "Order Confirm"
    color = "green"
  } else if (state == "Placed") {
    heading = "Order Pending"
    message = " we can take up to 20 minutes for payment confirmation "
    color = "red"
  } else if (state == "Payment Failed") {
    color = "red"
    heading = state
  } else {
    heading = state
  }

  return { heading, message, color }
}
